<!-- * * Inspirado em https://dev.to/cloudx/reusable-dynamic-modal-on-vue-3-1k56 -->

<template>
  <div>
    <CModal
      :visible="modalStore.isOpen"
      v-bind="modalStore.CModalProps"
      @close="modalStore.close"
    >
      <CModalHeader v-if="modalStore.hasHeader">
        <div>
          <CModalTitle class="tw-text-2xl tw-font-bold">
            {{ modalStore.title }}
          </CModalTitle>
          <CModalTitle
            v-if="modalStore.subTitle"
            class="tw-text-sm tw-text-gray-500 tw-mt-1 tw-mb-0"
          >
            {{ modalStore.subTitle }}
          </CModalTitle>
        </div>
      </CModalHeader>
      <CModalBody>
        <component :is="modalStore.view" />
      </CModalBody>
      <CModalFooter
        v-if="modalStore.actions && modalStore.actions?.length > 0"
        class="tw-mt-auto"
      >
        <div class="tw-flex tw-gap-1">
          <!-- * * Renderiza todas actions e passa o model payload como param -->
          <CLoadingButton
            v-for="action in modalStore.actions"
            :key="action.id"
            v-bind="action.cLoadingButtonProps"
            @click="action.callback"
          >
            {{ action.label }}
          </CLoadingButton>
        </div>
      </CModalFooter>
    </CModal>
  </div>
</template>

<script lang="ts" setup>
const modalStore = useModalStore()
</script>

<style></style>
